export const continueLoop = {
  configuration: {
    loopHash: "Schleife Element"
  }
};
